/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {familiesSavingsScreens} from '../api'

export const useMutationFamiliesSavingsScreens = createReactQueryMutationHook('familiesSavingsScreens', familiesSavingsScreens)
